<template>
  <tr v-if="showRow">
    <td>
      <router-link :to="'/company/review/edit/' + review.review_id">{{review.review_id}}</router-link>
    </td>
    <td>{{review.created_at|dateFormat('YYYY/MM/DD HH:mm')}}</td>
    <td>{{review.company_name}}</td>
    <td>
      <router-link :to="'/company/review/edit/' + review.review_id">{{review.project_title}}</router-link>
    </td>
    <td>
      <template v-if="review.is_public">公開</template>
      <template v-if="!review.is_public">非公開</template>
    </td>
    <td>
    </td>
  </tr>
</template>
<script>
export default {
  props: ['review'],
  data: function () {
    return {
      errors: false,
      showRow: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// ListRow.vue?6bfad514